// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__GY2eA"};